/**
 * Alternate ID type strings used by NNR templates for display.
 * Kept local to avoid pulling encamp-shared into the Oak ESM/Rollup bundle (CJS interop issues).
 * Values must match encamp-shared FacilityAlternateIdKnownKind for TIER2_AZ and TIER2_MANAGER.
 */
export const NNR_DISPLAY_ID_TYPES = {
    TIER2_AZ: "TIER2_AZ",
    TIER2_MANAGER: "TIER2_MANAGER",
};
//# sourceMappingURL=alternateIdKinds.js.map